import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { MultiWalletStats } from './MultiWalletStats';
import { WalletList } from './WalletList';
import { AggregatedPortfolio } from './AggregatedPortfolio';
import { MultiWalletActivity } from './MultiWalletActivity';
import { AddWalletModal } from './AddWalletModal';
import { useWallet } from '../wallet/WalletProvider';
import { Wallet, Plus, PieChart, Activity, LayoutGrid } from 'lucide-react';

export function MultiWalletDashboard() {
  const { isConnected } = useWallet();
  const [activeTab, setActiveTab] = useState('overview');
  const [showAddWallet, setShowAddWallet] = useState(false);

  if (!isConnected) {
    return (
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Wallet className="h-5 w-5 text-violet-500" />
            Multi-Wallet Dashboard
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-slate-600 dark:text-slate-400">
            Conecta tu wallet principal para gestionar multiples wallets desde un solo lugar.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-3">
            <Wallet className="h-8 w-8 text-violet-500" />
            Multi-Wallet Dashboard
          </h1>
          <p className="text-slate-600 dark:text-slate-400 mt-2">
            Gestiona y visualiza todos tus activos en multiples wallets y cadenas
          </p>
        </div>
        <Button
          onClick={() => setShowAddWallet(true)}
          className="bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700"
        >
          <Plus className="mr-2 h-4 w-4" />
          Agregar Wallet
        </Button>
      </div>

      {/* Stats Overview */}
      <MultiWalletStats />

      {/* Add Wallet Modal */}
      {showAddWallet && (
        <AddWalletModal onClose={() => setShowAddWallet(false)} />
      )}

      {/* Main Content */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="overview" className="flex items-center gap-2">
            <LayoutGrid className="h-4 w-4" />
            Vista General
          </TabsTrigger>
          <TabsTrigger value="portfolio" className="flex items-center gap-2">
            <PieChart className="h-4 w-4" />
            Portfolio Agregado
          </TabsTrigger>
          <TabsTrigger value="activity" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Actividad
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <WalletList />
        </TabsContent>

        <TabsContent value="portfolio" className="space-y-6">
          <AggregatedPortfolio />
        </TabsContent>

        <TabsContent value="activity" className="space-y-6">
          <MultiWalletActivity />
        </TabsContent>
      </Tabs>
    </div>
  );
}
